import React, { useMemo } from 'react';
import {
    CallRecordKeysByDate,
    CallRecordRow,
    callHistoryRowKey,
    callRecordKeyDates,
    rowIsFocusable,
} from 'flow/components/call-history-v2/call-history-rows';
import DateGroupedList, {
    DateGroupedRowProps,
} from 'flow/components/call-history-v2/DateGroupedList';
import MissedQueueCallItem from './MissedQueueCallItem';

interface Props {
    callRecordKeysByDate: CallRecordKeysByDate;
}

/** The missed queue calls by date, with the rows of the PBX call history. */
const MissedQueueCallsList = ({ callRecordKeysByDate }: Props) => {
    const dates = useMemo(
        () => callRecordKeyDates(callRecordKeysByDate),
        [callRecordKeysByDate],
    );

    const renderRow = (row: CallRecordRow, rowProps: DateGroupedRowProps) => (
        <MissedQueueCallItem callRecordKey={row.callRecordKey} {...rowProps} />
    );

    return (
        <DateGroupedList
            dates={dates}
            rowKey={callHistoryRowKey}
            rowIsFocusable={rowIsFocusable}
            renderRow={renderRow}
            // The widget's card, so the date titles stand on its colour.
            bgClassName="dark:bg-gray-100"
        />
    );
};

export default React.memo(MissedQueueCallsList);
